var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4421 3.42495L12.9087 6.35828C13.1087 6.76662 13.6421 7.15828 14.0921 7.23328L16.7504 7.67495C18.4504 7.95828 18.8504 9.19162 17.6254 10.4083L15.5587 12.475C15.2087 12.825 15.0171 13.5 15.1254 13.9833L15.7171 16.5416C16.1837 18.5666 15.1087 19.35 13.3171 18.2916L10.8254 16.8166C10.3754 16.55 9.63375 16.55 9.17541 16.8166L6.68375 18.2916C4.90041 19.35 3.81708 18.5583 4.28375 16.5416L4.87541 13.9833C4.98375 13.5 4.79208 12.825 4.44208 12.475L2.37541 10.4083C1.15875 9.19162 1.55041 7.95828 3.25041 7.67495L5.90875 7.23328C6.35041 7.15828 6.88375 6.76662 7.08375 6.35828L8.55041 3.42495C9.35041 1.83328 10.6504 1.83328 11.4421 3.42495Z",
    fill: "#C4D26E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4043c8513083e2d5f99e67b5e8340ab1.svg";
export { ForwardRef as ReactComponent };